exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._double-bounce__double-bounce__viU7w {\n  position: relative;\n  margin: auto; }\n  ._double-bounce__double-bounce__viU7w ._double-bounce__child__1fJt6 {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    opacity: 0.6;\n    position: absolute;\n    top: 0;\n    left: 0;\n    animation: _double-bounce__sk-doubleBounce__3TN2j 2.0s infinite ease-in-out; }\n  ._double-bounce__double-bounce__viU7w ._double-bounce__bounce2__37n8Z {\n    animation-delay: -1.0s; }\n\n@keyframes _double-bounce__sk-doubleBounce__3TN2j {\n  0%, 100% {\n    transform: scale(0); }\n  50% {\n    transform: scale(1); } }\n", ""]);

// exports
exports.locals = {
	"double-bounce": "_double-bounce__double-bounce__viU7w",
	"child": "_double-bounce__child__1fJt6",
	"sk-doubleBounce": "_double-bounce__sk-doubleBounce__3TN2j",
	"bounce2": "_double-bounce__bounce2__37n8Z"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]__[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/rctui/styles/spin/_double-bounce.scss
// module id = 415
// module chunks = 0 1